define(function(require) {

	const tpl = require('civicsViews/log_links/t_itv_log_link.hbs');
	const create_log_view = require('civicsViews/create_log/v_lov_create_log');

	return Marionette.LayoutView.extend({
		tagName: 'li',
		className: 'log-link-row',
		template: tpl,
		events: {
			'click @ui.logLink': 'logLinkClicked',
		},
		ui: {
			logLink: '.log-link'
		},
		regions: {
			logLinkRegion: {
				selector: '.log-link-modal-container'
			}
		},
		modelEvents: {},
		initialize: function(options) {
			this.config = options.config;
			this.modalRegion = options.modalRegion;
			this.modelJSON = this.model.toJSON();
			this.instrumentType = options.instrumentType;
			this.instrumentID = options.instrumentID;
			this.canUpdateStatus = options.canUpdateStatus;
			this.isModal = options.isModal;
		},
		logLinkClicked: function(e) {
			e.preventDefault();
			var logLinkView = new create_log_view({
				config: this.config,
				modalRegion: this.isModal ? null : this.modalRegion,
				title: this.modelJSON.linkText,
				instructions: this.modelJSON.instructionText,
				type: this.modelJSON.logTypeCode,
				instrumentType: this.instrumentType,
				instrumentID: this.instrumentID,
				canUpdateStatus: this.canUpdateStatus && (!this.modelJSON.statusCode ? false : (this.modelJSON.statusCode.trim() != '' ? true : false)),
				submitButtonText: this.modelJSON.linkText,
				cancelButtonText: i18n.t('CIVICS.COMMON.BACK'),
				allowComments: this.modelJSON.allowComments,
				statusCode: !this.modelJSON.statusCode ? '' : (this.modelJSON.statusCode.trim() != '' ? this.modelJSON.statusCode : ''),
			});
			
			if(this.isModal)
				this.showChildView('logLinkRegion', logLinkView);
			else{
				this.modalRegion.show(logLinkView);
				this.modalRegion.showModal();
			}
			return false;
		},
		templateHelpers: function() {
			var self = this;
			var mdl = self.model.toJSON();
			return {
				linkText: mdl.linkText,
				linkLabel: mdl.linkLabel,
				link: (!mdl.link ? '#' : mdl.link),
				linkType: (!mdl.linkType ? 'secondary' : mdl.linkType),
				isClone: mdl.linkType == 'secondary' && mdl.linkText == i18n.t('CIVICS.INSTRUMENT_DETAIL.CLONE')
			};
		}
	});
});
